{
  "lastUpdatedAt": "2026-05-05T10:25:11.501Z",
  "lastFetchAttemptAt": "2026-05-05T10:25:11.501Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}